import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader

import Vue from 'vue'
import Vuetify from 'vuetify'
import currency from 'v-currency-field'
import VueI18n from 'vue-i18n'

import router from '@/router/index.js'
import store from '@/store.js'
import API from '@/plugins/api.js'
import Helpers from '@/plugins/helpers.js'
import ModalBus from '@/plugins/modal-bus.js'
import Languages from '@/languages/languages.js'
import handle_session_error from '@/helpers/handle_session_error.js'
import App from '@/App.vue'

Vue.use(currency)
Vue.use(API)
Vue.use(Helpers)
Vue.use(ModalBus)
Vue.use(Vuetify, {
  iconfont: 'fa',
  theme: {
    primary: '#88C143',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#BF6F6D',
    info: '#6F6F6F',
    success: '#88C143',
    warning: '#FFC107',
  },
})
Vue.use(VueI18n)
Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: 'hr',
  messages: Languages.translations,
})

function handle_router_before_each(to, next) {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next() // Good.
    } else {
      next({ name: 'Login' }) // Redirect to Login.
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (!store.getters.isAuthenticated) {
      next() // Good.
    } else {
      next({ name: 'Dashboard' }) // Redirect to Dashboard.
    }
  } else {
    // Used for 404 page not found and etc.
    next()
  }
}

let initial_check_for_token_done = false

router.beforeEach((to, from, next) => {
  if (initial_check_for_token_done) {
    handle_router_before_each(to, next)
  } else {
    Vue.prototype.$APICall(
      'get',
      'COOKIE_TOKEN',
      '',
      {},
      data => {
        initial_check_for_token_done = true

        if (data.data.cookie === true) {
          store
            .dispatch('setLoggedIn', true)
            .then(() => {
              i18n.locale = store.state.user.language
              handle_router_before_each(to, next)
            })
            .catch(error => {
              handle_session_error(error, store, router, Vue.prototype.$prompt)
            })

          return
        }

        handle_router_before_each(to, next)
      },
      false
    )
  }
})

// After each route navigation, get app version
// It sets the `fvlive_version` cookie and if needed reloads the page.
router.afterEach(() => {
  Vue.prototype.$APICall(
    'get',
    'APP_VERSION',
    '',
    {},
    data => {
      if (Vue.prototype.$getCookie('fvlive_version') === '') {
        Vue.prototype.$setCookie('fvlive_version', data.data.version)
      } else if (
        data.data.version != Vue.prototype.$getCookie('fvlive_version')
      ) {
        Vue.prototype.$setCookie('fvlive_version', data.data.version)

        window.location.reload()
      }
    },
    false
  )
})

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
